const SHARE_DRAFT_KEY = "muulti_social_feed_component_share_v1";

function sanitizeGateInput(input) {
    if (!input || typeof input !== "object") return null;

    const logic = input?.logic === "all" ? "all" : "any";
    const gates = (Array.isArray(input?.gates) ? input.gates : [{ type: "public" }])
        .map((g) => {
            const type = String(g?.type || "public");
            if (type === "public") return { type: "public" };
            if (type === "donation") {
                return {
                    type: "donation",
                    donationCompId: String(g?.donationCompId || ""),
                    donationThreshold: Number(g?.donationThreshold || 0),
                    campaignName: String(g?.campaignName || ""),
                    currency: String(g?.currency || ""),
                    tokenMint: String(g?.tokenMint || ""),
                };
            }
            if (type === "directPayment") {
                return {
                    type: "directPayment",
                    priceSol: Number(g?.priceSol || 0),
                    payToUid: String(g?.payToUid || ""),
                    targetId: String(g?.targetId || ""),
                    currency: String(g?.currency || "SOL"),
                    tokenMint: String(g?.tokenMint || ""),
                };
            }
            if (type === "tokensHeld") {
                return {
                    type: "tokensHeld",
                    tokenThreshold: Number(g?.tokenThreshold || 0),
                    currency: String(g?.currency || "SOL"),
                    tokenMint: String(g?.tokenMint || ""),
                };
            }
            if (type === "token" || type === "collection" || type === "compressedCollection") {
                return {
                    type,
                    listId: String(g?.listId || ""),
                };
            }
            return null;
        })
        .filter(Boolean);

    return { logic, gates: gates.length ? gates : [{ type: "public" }] };
}

export function queueSocialFeedShareDraft(draft) {
    if (!draft || typeof window === "undefined") return false;

    try {
        const gateInput = sanitizeGateInput(draft.gateInput);
        const payload = {
            content: String(draft.content || ""),
            summary: String(draft.summary || ""),
            tags: Array.isArray(draft.tags) ? draft.tags.map((t) => String(t || "").trim()).filter(Boolean) : [],
            source: String(draft.source || ""),
            detailPath: String(draft.detailPath || ""),
            gateInput,
            createdAt: Date.now(),
        };

        window.sessionStorage.setItem(SHARE_DRAFT_KEY, JSON.stringify(payload));
        return true;
    } catch (err) {
        console.error("Failed to queue social feed share draft:", err);
        return false;
    }
}

export function consumeSocialFeedShareDraft() {
    if (typeof window === "undefined") return null;

    try {
        const raw = window.sessionStorage.getItem(SHARE_DRAFT_KEY);
        if (!raw) return null;
        window.sessionStorage.removeItem(SHARE_DRAFT_KEY);

        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") return null;

        return {
            content: String(parsed.content || ""),
            summary: String(parsed.summary || ""),
            tags: Array.isArray(parsed.tags) ? parsed.tags.map((t) => String(t || "").trim()).filter(Boolean) : [],
            source: String(parsed.source || ""),
            detailPath: String(parsed.detailPath || ""),
            gateInput: sanitizeGateInput(parsed.gateInput),
        };
    } catch (err) {
        console.error("Failed to consume social feed share draft:", err);
        return null;
    }
}
